/**
 * API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export type AvatarType = 'Unknown' | 'TB' | 'TG' | 'TW' | 'TS' | 'CAM_BH_01' | 'CAM_BH_02' | 'CAM_BH_03' | 'CAM_BH_04' | 'CAM_BH_05' | 'CAM_BH_06' | 'CAM_BH_07' | 'CAM_BH_08' | 'CAM_BH_09' | 'CAM_BH_10' | 'CAM_BH_11' | 'CAM_BH_12' | 'CAM_BH_SS_01' | 'CAM_BH_SS_02' | 'CAM_BH_SS_03' | 'CAM_BH_SS_04' | 'CAM_BH_SS_05' | 'CAM_BH_SS_06' | 'CAM_BH_SS_07' | 'CAM_BH_SS_08' | 'CAM_BH_SS_09' | 'CAM_BH_SS_10' | 'CAM_BH_SS_11' | 'CAM_BH_SS_12' | 'CAM_SH_01' | 'CAM_SH_02' | 'CAM_SH_03' | 'CAM_SH_04' | 'CAM_SH_05' | 'CAM_SH_06' | 'CAM_SH_07' | 'CAM_SH_08' | 'CAM_SH_09' | 'CAM_SH_10' | 'CAM_SH_11' | 'CAM_SH_12' | 'CAM_SH_SS_01' | 'CAM_SH_SS_02' | 'CAM_SH_SS_03' | 'CAM_SH_SS_04' | 'CAM_SH_SS_05' | 'CAM_SH_SS_06' | 'CAM_SH_SS_07' | 'CAM_SH_SS_08' | 'CAM_SH_SS_09' | 'CAM_SH_SS_10' | 'CAM_SH_SS_11' | 'CAM_SH_SS_12' | 'POLY_LS_AT_EASE_01' | 'POLY_LS_AT_EASE_02' | 'POLY_LS_AT_EASE_03' | 'POLY_LS_AT_EASE_04' | 'POLY_LS_AT_EASE_09' | 'POLY_LS_AT_EASE_10' | 'POLY_LS_AT_EASE_11' | 'POLY_LS_AT_EASE_12' | 'POLY_LS_AT_EASE_13' | 'POLY_LS_AT_EASE_14' | 'POLY_LS_AT_EASE_15' | 'POLY_LS_ATTENTION_01' | 'POLY_LS_ATTENTION_02' | 'POLY_LS_ATTENTION_03' | 'POLY_LS_ATTENTION_04' | 'POLY_LS_ATTENTION_09' | 'POLY_LS_ATTENTION_10' | 'POLY_LS_ATTENTION_11' | 'POLY_LS_ATTENTION_12' | 'POLY_LS_ATTENTION_13' | 'POLY_LS_ATTENTION_14' | 'POLY_LS_ATTENTION_15' | 'POLY_LS_ATTENTION_16' | 'POLY_LS_NEUTRAL_01' | 'POLY_LS_NEUTRAL_02' | 'POLY_LS_NEUTRAL_03' | 'POLY_LS_NEUTRAL_04' | 'POLY_LS_NEUTRAL_05' | 'POLY_LS_NEUTRAL_06' | 'POLY_LS_NEUTRAL_07' | 'POLY_LS_NEUTRAL_08' | 'POLY_LS_NEUTRAL_09' | 'POLY_LS_NEUTRAL_10' | 'POLY_LS_NEUTRAL_11' | 'POLY_LS_NEUTRAL_12' | 'POLY_SS_NEUTRAL_01' | 'POLY_SS_NEUTRAL_02' | 'POLY_SS_NEUTRAL_03' | 'POLY_SS_NEUTRAL_04' | 'POLY_SS_NEUTRAL_05' | 'POLY_SS_NEUTRAL_06' | 'POLY_SS_NEUTRAL_07' | 'POLY_SS_NEUTRAL_08' | 'POLY_SS_NEUTRAL_09' | 'POLY_SS_NEUTRAL_10' | 'POLY_SS_NEUTRAL_11' | 'POLY_SS_NEUTRAL_12' | 'CAM_CAP_LS_01' | 'CAM_CAP_LS_02' | 'CAM_CAP_LS_03' | 'CAM_CAP_LS_04' | 'CAM_CAP_LS_05' | 'CAM_CAP_LS_06' | 'CAM_CAP_LS_07' | 'CAM_CAP_LS_08' | 'CAM_CAP_LS_09' | 'CAM_CAP_LS_10' | 'CAM_CAP_LS_11' | 'CAM_CAP_LS_12' | 'CAM_CAP_SS_01' | 'CAM_CAP_SS_02' | 'CAM_CAP_SS_03' | 'CAM_CAP_SS_04' | 'CAM_CAP_SS_05' | 'CAM_CAP_SS_06' | 'CAM_CAP_SS_07' | 'CAM_CAP_SS_08' | 'CAM_CAP_SS_09' | 'CAM_CAP_SS_10' | 'CAM_CAP_SS_11' | 'CAM_CAP_SS_12' | 'POLY_LS_SALUTE_01' | 'POLY_LS_SALUTE_02' | 'POLY_LS_SALUTE_03' | 'POLY_LS_SALUTE_04';

export const AvatarType = {
    Unknown: 'Unknown' as AvatarType,
    TB: 'TB' as AvatarType,
    TG: 'TG' as AvatarType,
    TW: 'TW' as AvatarType,
    TS: 'TS' as AvatarType,
    CAMBH01: 'CAM_BH_01' as AvatarType,
    CAMBH02: 'CAM_BH_02' as AvatarType,
    CAMBH03: 'CAM_BH_03' as AvatarType,
    CAMBH04: 'CAM_BH_04' as AvatarType,
    CAMBH05: 'CAM_BH_05' as AvatarType,
    CAMBH06: 'CAM_BH_06' as AvatarType,
    CAMBH07: 'CAM_BH_07' as AvatarType,
    CAMBH08: 'CAM_BH_08' as AvatarType,
    CAMBH09: 'CAM_BH_09' as AvatarType,
    CAMBH10: 'CAM_BH_10' as AvatarType,
    CAMBH11: 'CAM_BH_11' as AvatarType,
    CAMBH12: 'CAM_BH_12' as AvatarType,
    CAMBHSS01: 'CAM_BH_SS_01' as AvatarType,
    CAMBHSS02: 'CAM_BH_SS_02' as AvatarType,
    CAMBHSS03: 'CAM_BH_SS_03' as AvatarType,
    CAMBHSS04: 'CAM_BH_SS_04' as AvatarType,
    CAMBHSS05: 'CAM_BH_SS_05' as AvatarType,
    CAMBHSS06: 'CAM_BH_SS_06' as AvatarType,
    CAMBHSS07: 'CAM_BH_SS_07' as AvatarType,
    CAMBHSS08: 'CAM_BH_SS_08' as AvatarType,
    CAMBHSS09: 'CAM_BH_SS_09' as AvatarType,
    CAMBHSS10: 'CAM_BH_SS_10' as AvatarType,
    CAMBHSS11: 'CAM_BH_SS_11' as AvatarType,
    CAMBHSS12: 'CAM_BH_SS_12' as AvatarType,
    CAMSH01: 'CAM_SH_01' as AvatarType,
    CAMSH02: 'CAM_SH_02' as AvatarType,
    CAMSH03: 'CAM_SH_03' as AvatarType,
    CAMSH04: 'CAM_SH_04' as AvatarType,
    CAMSH05: 'CAM_SH_05' as AvatarType,
    CAMSH06: 'CAM_SH_06' as AvatarType,
    CAMSH07: 'CAM_SH_07' as AvatarType,
    CAMSH08: 'CAM_SH_08' as AvatarType,
    CAMSH09: 'CAM_SH_09' as AvatarType,
    CAMSH10: 'CAM_SH_10' as AvatarType,
    CAMSH11: 'CAM_SH_11' as AvatarType,
    CAMSH12: 'CAM_SH_12' as AvatarType,
    CAMSHSS01: 'CAM_SH_SS_01' as AvatarType,
    CAMSHSS02: 'CAM_SH_SS_02' as AvatarType,
    CAMSHSS03: 'CAM_SH_SS_03' as AvatarType,
    CAMSHSS04: 'CAM_SH_SS_04' as AvatarType,
    CAMSHSS05: 'CAM_SH_SS_05' as AvatarType,
    CAMSHSS06: 'CAM_SH_SS_06' as AvatarType,
    CAMSHSS07: 'CAM_SH_SS_07' as AvatarType,
    CAMSHSS08: 'CAM_SH_SS_08' as AvatarType,
    CAMSHSS09: 'CAM_SH_SS_09' as AvatarType,
    CAMSHSS10: 'CAM_SH_SS_10' as AvatarType,
    CAMSHSS11: 'CAM_SH_SS_11' as AvatarType,
    CAMSHSS12: 'CAM_SH_SS_12' as AvatarType,
    POLYLSATEASE01: 'POLY_LS_AT_EASE_01' as AvatarType,
    POLYLSATEASE02: 'POLY_LS_AT_EASE_02' as AvatarType,
    POLYLSATEASE03: 'POLY_LS_AT_EASE_03' as AvatarType,
    POLYLSATEASE04: 'POLY_LS_AT_EASE_04' as AvatarType,
    POLYLSATEASE09: 'POLY_LS_AT_EASE_09' as AvatarType,
    POLYLSATEASE10: 'POLY_LS_AT_EASE_10' as AvatarType,
    POLYLSATEASE11: 'POLY_LS_AT_EASE_11' as AvatarType,
    POLYLSATEASE12: 'POLY_LS_AT_EASE_12' as AvatarType,
    POLYLSATEASE13: 'POLY_LS_AT_EASE_13' as AvatarType,
    POLYLSATEASE14: 'POLY_LS_AT_EASE_14' as AvatarType,
    POLYLSATEASE15: 'POLY_LS_AT_EASE_15' as AvatarType,
    POLYLSATTENTION01: 'POLY_LS_ATTENTION_01' as AvatarType,
    POLYLSATTENTION02: 'POLY_LS_ATTENTION_02' as AvatarType,
    POLYLSATTENTION03: 'POLY_LS_ATTENTION_03' as AvatarType,
    POLYLSATTENTION04: 'POLY_LS_ATTENTION_04' as AvatarType,
    POLYLSATTENTION09: 'POLY_LS_ATTENTION_09' as AvatarType,
    POLYLSATTENTION10: 'POLY_LS_ATTENTION_10' as AvatarType,
    POLYLSATTENTION11: 'POLY_LS_ATTENTION_11' as AvatarType,
    POLYLSATTENTION12: 'POLY_LS_ATTENTION_12' as AvatarType,
    POLYLSATTENTION13: 'POLY_LS_ATTENTION_13' as AvatarType,
    POLYLSATTENTION14: 'POLY_LS_ATTENTION_14' as AvatarType,
    POLYLSATTENTION15: 'POLY_LS_ATTENTION_15' as AvatarType,
    POLYLSATTENTION16: 'POLY_LS_ATTENTION_16' as AvatarType,
    POLYLSNEUTRAL01: 'POLY_LS_NEUTRAL_01' as AvatarType,
    POLYLSNEUTRAL02: 'POLY_LS_NEUTRAL_02' as AvatarType,
    POLYLSNEUTRAL03: 'POLY_LS_NEUTRAL_03' as AvatarType,
    POLYLSNEUTRAL04: 'POLY_LS_NEUTRAL_04' as AvatarType,
    POLYLSNEUTRAL05: 'POLY_LS_NEUTRAL_05' as AvatarType,
    POLYLSNEUTRAL06: 'POLY_LS_NEUTRAL_06' as AvatarType,
    POLYLSNEUTRAL07: 'POLY_LS_NEUTRAL_07' as AvatarType,
    POLYLSNEUTRAL08: 'POLY_LS_NEUTRAL_08' as AvatarType,
    POLYLSNEUTRAL09: 'POLY_LS_NEUTRAL_09' as AvatarType,
    POLYLSNEUTRAL10: 'POLY_LS_NEUTRAL_10' as AvatarType,
    POLYLSNEUTRAL11: 'POLY_LS_NEUTRAL_11' as AvatarType,
    POLYLSNEUTRAL12: 'POLY_LS_NEUTRAL_12' as AvatarType,
    POLYSSNEUTRAL01: 'POLY_SS_NEUTRAL_01' as AvatarType,
    POLYSSNEUTRAL02: 'POLY_SS_NEUTRAL_02' as AvatarType,
    POLYSSNEUTRAL03: 'POLY_SS_NEUTRAL_03' as AvatarType,
    POLYSSNEUTRAL04: 'POLY_SS_NEUTRAL_04' as AvatarType,
    POLYSSNEUTRAL05: 'POLY_SS_NEUTRAL_05' as AvatarType,
    POLYSSNEUTRAL06: 'POLY_SS_NEUTRAL_06' as AvatarType,
    POLYSSNEUTRAL07: 'POLY_SS_NEUTRAL_07' as AvatarType,
    POLYSSNEUTRAL08: 'POLY_SS_NEUTRAL_08' as AvatarType,
    POLYSSNEUTRAL09: 'POLY_SS_NEUTRAL_09' as AvatarType,
    POLYSSNEUTRAL10: 'POLY_SS_NEUTRAL_10' as AvatarType,
    POLYSSNEUTRAL11: 'POLY_SS_NEUTRAL_11' as AvatarType,
    POLYSSNEUTRAL12: 'POLY_SS_NEUTRAL_12' as AvatarType,
    CAMCAPLS01: 'CAM_CAP_LS_01' as AvatarType,
    CAMCAPLS02: 'CAM_CAP_LS_02' as AvatarType,
    CAMCAPLS03: 'CAM_CAP_LS_03' as AvatarType,
    CAMCAPLS04: 'CAM_CAP_LS_04' as AvatarType,
    CAMCAPLS05: 'CAM_CAP_LS_05' as AvatarType,
    CAMCAPLS06: 'CAM_CAP_LS_06' as AvatarType,
    CAMCAPLS07: 'CAM_CAP_LS_07' as AvatarType,
    CAMCAPLS08: 'CAM_CAP_LS_08' as AvatarType,
    CAMCAPLS09: 'CAM_CAP_LS_09' as AvatarType,
    CAMCAPLS10: 'CAM_CAP_LS_10' as AvatarType,
    CAMCAPLS11: 'CAM_CAP_LS_11' as AvatarType,
    CAMCAPLS12: 'CAM_CAP_LS_12' as AvatarType,
    CAMCAPSS01: 'CAM_CAP_SS_01' as AvatarType,
    CAMCAPSS02: 'CAM_CAP_SS_02' as AvatarType,
    CAMCAPSS03: 'CAM_CAP_SS_03' as AvatarType,
    CAMCAPSS04: 'CAM_CAP_SS_04' as AvatarType,
    CAMCAPSS05: 'CAM_CAP_SS_05' as AvatarType,
    CAMCAPSS06: 'CAM_CAP_SS_06' as AvatarType,
    CAMCAPSS07: 'CAM_CAP_SS_07' as AvatarType,
    CAMCAPSS08: 'CAM_CAP_SS_08' as AvatarType,
    CAMCAPSS09: 'CAM_CAP_SS_09' as AvatarType,
    CAMCAPSS10: 'CAM_CAP_SS_10' as AvatarType,
    CAMCAPSS11: 'CAM_CAP_SS_11' as AvatarType,
    CAMCAPSS12: 'CAM_CAP_SS_12' as AvatarType,
    POLYLSSALUTE01: 'POLY_LS_SALUTE_01' as AvatarType,
    POLYLSSALUTE02: 'POLY_LS_SALUTE_02' as AvatarType,
    POLYLSSALUTE03: 'POLY_LS_SALUTE_03' as AvatarType,
    POLYLSSALUTE04: 'POLY_LS_SALUTE_04' as AvatarType
};